import { render } from "./photoListExport.vue?vue&type=template&id=350f64a6&ts=true"
import script from "./photoListExport.vue?vue&type=script&lang=ts"
export * from "./photoListExport.vue?vue&type=script&lang=ts"

import "./photoListExport.vue?vue&type=style&index=0&id=350f64a6&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__